import { DEFAULT_CONFIG_STRINGS } from "@/mocks/config"

export const FALLBACK_CONFIG_STRINGS: Record<string, string> = {
  config_quest_selection: "Choose Your Quest",
  config_quest_selection_subtitle: "A Quest is a personalized experience.",
  config_quest_waitlist: "Coming soon",
  config_button_share: "Share",
  config_button_contents: "Contents",
  config_button_complete: "Mark as completed",
  config_quest_completion_title: "You completed the '{quest_name}' Quest",
  config_button_quest_next: "Take a new quest",
  config_share_title: "Share this content",
  config_button_share_link: "Copy link",
  config_quest_completion:
    "You've learned a lot right? Also, you shared great moments with your loved ones. Take a moment to celebrate with your family. Remember you can always revisit this module to reinforce what you've learned.",
  config_button_continue: "Get started",
  config_button_quest_preview: "Preview quest",
  config_button_quest_continue: "Continue quest",
  config_button_quest_notify: "Notify me",
  config_button_quest_subscribed: "Subscribed",
  config_toast_quest_subscribed: "Subscribed to '{quest_name}' quest",
  config_badge_recommended: "Recommended",
  config_button_start_mission: "Start mission {index}",
  config_header_stage: "Stage {index}",
  config_header_mission: "Mission {index}",
  config_loading_resource: "Processing {resource}…",
  config_loading_resource_error: "Couldn't process {resource}",
  config_resource_config: "Configuration",
  config_resource_circle: "Circle",
  config_resource_quest: "Quest",
  config_resource_mission: "Mission",
  config_resource_attempt: "Attempt",
  config_resource_user: "User",
  config_login_email: "Email",
  config_login_email_placeholder: "email",
  config_login_password: "Password",
  config_login_password_placeholder: "Your password",
  config_login_button_submit: "Submit",
  config_logout_button: "Log out",
  config_toast_question_answered: "Log out",
  config_question_button_previous: "Previous",
  config_question_button_next: "Next",
  config_question_button_finish: "Finish",
  config_question_button_submitting: "Sending…",
  config_login_title: "Login",
  config_login_description:
    "Welcome to Pandora's Way. Please enter your email and password to log in.",
  config_login_email_error: "This doesn't look like a valid email.",
  config_login_button_submitting: "Logging in…",
  config_sign_up_title: "Create an account",
  config_sign_up_description: "Sign Up to continue your journey",
  config_sign_up_email_label: "Email address",
  config_sign_up_email_placeholder: "Enter a valid email address",
  config_sign_up_button_continue: "Continue",
  config_sign_up_button_submitting: "Submitting…",
  config_sign_up_login:
    "If you already have an account go to [{login_text}]({login_url}).",
  config_sign_up_login_text: "Login",
  config_sign_up_footer:
    "By creating an account you accept our [{terms_text}]({terms_url}) and have read and acknowledge our [{privacy_text}]({privacy_url}).",
  config_sign_up_terms_text: "Terms & Conditions",
  config_sign_up_privacy_text: "Privacy policy",
  config_quest_accordion: "Contents",
  config_button_quest_review: "Review quest",
  config_forgot_password_title: "Forgot your password?",
  config_forgot_password_description:
    "Enter the email you use to access your account and we'll send you instructions to reset your password.",
  config_forgot_password_email_label: "Email",
  config_forgot_password_email_placeholder: "Your email address",
  config_forgot_password_error_email_invalid: "Invalid email",
  config_forgot_password_error_email_short: "Email too short",
  config_forgot_password_error_email_long: "Email too long",
  config_forgot_password_error_generic: "Error sending your email",
  config_forgot_password_email_title: "Check your inbox",
  config_forgot_password_email_body:
    "We sent you an email. If it's not in your inbox, check your Spam or double-check your email address.",
  config_forgot_password_button_submitting: "Submitting…",
  config_forgot_password_button_continue: "Continue",
  config_reset_password_title: "Reset your password",
  config_reset_password_description: "Create a new password for Pandora's Way",
  config_reset_password_new_label: "New password",
  config_reset_password_new_placeholder: "Your new password",
  config_reset_password_confirm_label: "Confirm your new password",
  config_reset_password_confirm_placeholder: "Your new password",
  config_reset_password_button_continue: "Continue",
  config_reset_password_button_submitting: "Submitting…",
  config_reset_password_button_show: "Show",
  config_reset_password_button_hide: "Hide",
  config_reset_password_success_title: "Your password has been updated",
  config_reset_password_success_description:
    "You can log in using your new credentials.",
  config_reset_password_success_button: "Go to login",
  config_reset_password_error_generic:
    "There's an issue with your password reset. Please contact support@pandorasway.com",
  config_reset_password_error_code:
    "Code('{code}') cannot be used to reset password",
  config_sign_up_profile_success: "Account created",
  config_sign_up_success_title: "Check your inbox",
  config_sign_up_success_body:
    "We've sent an email to **{email}**. Tap on the link to verify your new email address.",
  config_sign_up_success_toast: "Email resent",
  config_sign_up_success_button: "Resend link",
  config_sign_up_profile_error_name_short: "Name is too short",
  config_sign_up_profile_error_no_code: "Unable to find sign up code.",
  config_sign_up_profile_error_generic:
    "An error happened while creating the account.",
  config_sign_up_profile_password_placeholder: "Password",
  config_sign_up_profile_title: "Before we begin",
  config_sign_up_profile_description_title: "Set up your profile",
  config_sign_up_profile_description:
    "Add your name and password to get started with Pandora's Way.",
  config_sign_up_profile_password_label: "Create a new password",
  config_sign_up_profile_name_label: "Enter your full name",
  config_sign_up_profile_error_name_long: "Name is too long",
  config_sign_up_profile_name_placeholder: "Full name",
  config_sign_up_profile_button_submitting: "Submitting…",
  config_sign_up_profile_button_continue: "Continue",
  config_sign_up_profile_button_hide: "Hide",
  config_sign_up_profile_button_show: "Show",
  config_sign_up_error_generic: "Unknown error happened",
  config_sign_up_error_conflict: "This email is already in use.",
}

export const FALLBACK_STRINGS: Record<string, string> = {
  ...DEFAULT_CONFIG_STRINGS,
  ...FALLBACK_CONFIG_STRINGS,
}
